import { Link, useLocation, useNavigate } from 'react-router-dom';
import { clearToken } from '../lib/auth';

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  function handleLogout() {
    clearToken();
    navigate('/login');
  }

  function isActive(path: string): boolean {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }

  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-name">
          one fifty<b>.</b>
        </div>
        <div className="brand-sub">ADMIN</div>
      </div>

      <div className="nav-group">
        <div className="nav-label">MAIN</div>
        <NavItem to="/friends" label="友だち / メッセージ" active={isActive('/friends')} />
      </div>

      <div className="nav-group">
        <div className="nav-label">ANALYTICS</div>
        <NavItem
          to="/inflow-routes"
          label="流入経路"
          active={isActive('/inflow-routes')}
        />
        <NavItem
          to="/statuses"
          label="ステータス管理"
          active={isActive('/statuses')}
        />
        <NavItem to="/tags" label="タグ管理" active={isActive('/tags')} />
      </div>

      <div className="sidebar-footer">
        <div className="avatar-sm">N</div>
        <div className="me-info">
          <div className="me-name">のぞみ</div>
          <div className="me-email">nozom3512...</div>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          logout
        </button>
      </div>
    </aside>
  );
}

function NavItem({
  to,
  label,
  active,
}: {
  to: string;
  label: string;
  active: boolean;
}) {
  return (
    <Link to={to} className={`nav-item ${active ? 'active' : ''}`}>
      <span className="nav-icon">{active ? '●' : '○'}</span>
      {label}
    </Link>
  );
}
